module.exports = __webpack_public_path__ + "img/sunny-day.48094d12.svg";